/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-alert */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-cycle */
import React, { useState, useEffect } from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useNavigate, Link } from 'react-router-dom';
import { AccordionComponent } from '@syncfusion/ej2-react-navigations';
import { DialogUtility } from '@syncfusion/ej2-react-popups';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { RadioButtonComponent, CheckBoxComponent, ButtonComponent } from '@syncfusion/ej2-react-buttons'; // ButtonComponent
import { OtpInputComponent } from '@syncfusion/ej2-react-inputs';
import { Button } from '.';
import { useStateContext } from '../contexts/ContextProvider';
// import { Methods } from '../pages';
import { userProfileData } from '../data/dummy';

const UserProfile = () => {
  const { currentColor, setIdleLogout } = useStateContext();
  const { REACT_APP_API_ENDPOINT } = process.env;
  const { REACT_APP_ENV } = process.env;
  const props = JSON.parse(localStorage.getItem('user'));
  const [twoFA, setTwoFA] = useState('na');
  let loggedIn = false;
  const {
    setIsClicked,
    isMobile,
  } = useStateContext();
  let pages = [
  ];
  const containerStyle = {
    display: 'flex',
    justifyContent: 'flex-start', // Pushes the button to the right
    padding: '20px',
  };
  const containerStyle1 = {
    display: 'flex',
    justifyContent: 'flex-end', // Pushes the button to the right
    padding: '20px',
  };
  const idles = [
    { text: '15 minutes', id: '15' },
    { text: '30 minutes', id: '30' },
    { text: '60 minutes', id: '60' },
  ];
  const fields = { text: 'text', value: 'id' };

  const [smsChecked, setSmsChecked] = useState(null);
  const [smsCheckedMarketing, setSmsCheckedMarketing] = useState(null);
  const [emailChecked, setEmailChecked] = useState(null);
  const [address, setAddress] = useState('');
  const [address1, setAddress1] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  if (props) {
    loggedIn = props.loggedIn;
    // setEmail(props.email);
  }
  const navigate = useNavigate();
  const handleSubmit = () => {
    localStorage.removeItem('user');

    window.location.assign('/login');
  };
  const handleValueChange = async (args) => {
    const url = `${REACT_APP_API_ENDPOINT}/2fa?passcode=${args.value}`;
    if (args.value.length !== 6) {
      return;
    }
    if (props && props.token && props.token.length > 0) {
      await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${props.token}`,
        },
        body: JSON.stringify(props),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.response === 'OK') {
            DialogUtility.alert(`Success ${responseJson.response}`);
          } else {
            DialogUtility.alert(`${responseJson.response}`);
          }
        })
        .catch((e) => {
          DialogUtility.alert(`Error logging in ${e.message} ${REACT_APP_API_ENDPOINT}`);
        });
    }
  };

  let dialogInstance;
  function dialogOK(f, e) {
    dialogInstance.hide();
  }
  function formatPhoneNumber(phoneNumberString) {
    const cleaned = (`${phoneNumberString}`).replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      const intlCode = (match[1] ? '+1 ' : '');
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
  }

  function dialogClick(f, hdr, content, e) {
    const ok = null;
    dialogInstance = DialogUtility.confirm({
      title: hdr,
      content,
      okButton: ok,
      cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  }

  // const { loading, data } = Methods('user', 'GET', '') || {};
  // START
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);
  useEffect(() => {
    // fetch data
    const userFetch = async () => {
      const query = Object.entries(props)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/user?${query}`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${props.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          // Orig set state when the data received
          setData(mydata);
          if (!mydata || !mydata.user || !mydata.user.twoFA) {
            setTwoFA('na');
          } else {
            setTwoFA(mydata.user.twoFA);
          }
          setLoading(false);
        })
        .catch(() => {
        });
    };
    userFetch();
  }, [reload]);

  // Stop
  useEffect(() => {
    if (data && data.user) {
      if (data.user.smsOptin) {
        setSmsChecked(true);
      } else {
        setSmsChecked(false);
      }
      if (data.user.emailOptin) {
        setEmailChecked(true);
      } else {
        setEmailChecked(false);
      }
    }
    return () => {
      // setSmsChecked(null);
      // setEmailChecked(null);
    };
  }, [data]);
  const [qrcode, setQRCode] = useState(null);
  const [changeQR, setChangeQR] = useState(false);
  useEffect(() => {
    const getQRCode = () => {
      fetch(`${REACT_APP_API_ENDPOINT}/2fa?email=${props.email}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${props.token}`,
        },
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.response === 'OK') {
            const qrUrl = `${REACT_APP_API_ENDPOINT}/otpdown?userid=${props._id}.png`;
            setQRCode(qrUrl);
          }
        // The added/edited data will be saved in the Grid
        })
        .catch((error) => {
          console.error(error);
        });
    };
    getQRCode();
  }, [changeQR]);

  if (loading) {
    return <p>Loading... </p>;
  }
  if (data.role && data.role.dashboard && data.role.dashboard.permissions && data.role.dashboard.permissions.includes('Read')) {
    pages.push({ id: 'dashboard', text: 'Dashboard' });
  }
  if (data.role && data.role.reports && data.role.reports.permissions && data.role.reports.permissions.includes('Read')) {
    pages.push({ id: 'reports', text: 'Reports' });
  }
  if (data.role && data.role.organizations && data.role.organizations.permissions && data.role.organizations.permissions.includes('Read')) {
    pages.push({ id: 'organizations', text: 'Organizations' });
  }
  if (data.role && data.role.users && data.role.users.permissions && data.role.users.permissions.includes('Read')) {
    pages.push({ id: 'users', text: 'Users' });
  }
  if (data.role && data.role.roles && data.role.roles.permissions && data.role.roles.permissions.includes('Read')) {
    pages.push({ id: 'roles', text: 'Roles' });
  }
  if (data.role && data.role.associates && data.role.associates.permissions && data.role.associates.permissions.includes('Read')) {
    pages.push({ id: 'associatescontrolcenter', text: 'Associates' });
    pages.push({ id: 'associatepage', text: 'Associate' });
    pages.push({ id: 'managercontrolcenter', text: 'Managers' });
  }
  if (data.role && data.role.dashboard && data.role.dashboard.permissions && data.role.dashboard.permissions.includes('Read')) {
    pages.push({ id: 'inventorycontrolcenter', text: 'Devices' });
    pages.push({ id: 'inventorypage', text: 'Device' });
    pages.push({ id: 'card', text: 'Card' });
  }
  if (data.role && data.role.alerts && data.role.alerts.permissions && data.role.alerts.permissions.includes('Read')) {
    pages.push({ id: 'alerts', text: 'Alerts' });
  }
  if (data.role && data.role.calendar && data.role.calendar.permissions && data.role.calendar.permissions.includes('Read')) {
    pages.push({ id: 'calendar', text: 'Calendar' });
  }
  pages = [...pages].sort((a, b) => {
    if (a.id < b.id) return -1;
    if (a.id > b.id) return 1;
    return 0;
  });
  const handleChange = (event) => {
    // 👇️ this is the checkbox itself user
    data.user.smsOptin = smsChecked;
    data.user.smsOptinMarketing = smsCheckedMarketing;
    data.user.emailOptin = emailChecked;
    if (event.target.id === 'optinsms') {
      setSmsChecked(event.target.checked);
      // 👇️ this is the checked value of the field
      if (event.target.checked || event.target.checked === 'true') {
        data.user.smsOptin = true;
        setSmsChecked(true);
      } else {
        data.user.smsOptin = false;
        if (data.user.twoFA === 'sms') {
          data.user.twoFA = 'na';
          setTwoFA('na');
        }
        setSmsChecked(false);
      }
    } else if (event.target.id === 'optinsms1') {
      setSmsCheckedMarketing(event.target.checked);
      // 👇️ this is the checked value of the field
      if (event.target.checked || event.target.checked === 'true') {
        data.user.smsOptinMarketing = true;
        setSmsCheckedMarketing(true);
      } else {
        data.user.smsOptinMarketing = false;
        setSmsCheckedMarketing(false);
      }
    } else if (event.target.id === 'optinemail') {
      setEmailChecked(event.target.checked);
      // 👇️ this is the checked value of the field
      if (event.target.checked || event.target.checked === 'true') {
        data.user.emailOptin = true;
        setEmailChecked(true);
      } else {
        data.user.emailOptin = false;
        setEmailChecked(false);
      }
    } else if (event.target.type === 'radio') {
      if (event.value === 'sms' && (!data.user || !data.user.mobile || data.user.mobile.length < 10)) {
        DialogUtility.alert('User does not have a valid mobile number!');
        setTwoFA('na');
        return;
      } if (event.value === 'email' && (!data.user.email || !data.user.email.includes('@') || !data.user.email.includes('.') || data.user.email.length <= 7)) {
        DialogUtility.alert('Email is not valid!');
        setTwoFA('na');
        return;
      }
      data.user.twoFA = event.value;
      setTwoFA(event.value);
    } else {
      return;
    }
    setChangeQR(!changeQR);
    if (data.user.lastLogin && data.user.lastLogin === '') {
      data.user.lastLogin = '1970-01-01T00:00:00.000Z';
    }
    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${props.token}`,
      },
      body: JSON.stringify(data.user),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        data.user.emailOptin = responseJson.emailOptin;
        data.user.smsOptin = responseJson.smsOptin;
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        console.error(error);
      });
  };
  function okClick() {
    setIsClicked('notification', false);

    const curpwd = document.getElementById('cpwd').value;
    const newpwd = document.getElementById('npwd').value;
    const confirmpwd = document.getElementById('fpwd').value;

    if (newpwd === '' || confirmpwd === '') {
      dialogClick('na', 'Password Update', `Please enter matching new and confirm passwords ${newpwd} ${confirmpwd} ${confirmpwd}`, null);
      return;
    }

    if (curpwd.length < 7 || newpwd.length < 7) {
      dialogClick('na', 'Password Update', 'The new password must be 8 characters or longer', null);
      return;
    }
    if (newpwd !== confirmpwd) {
      dialogClick('na', 'Password Update', 'New password does not match confirm password.', null);
      return;
    }
    props.newPassword = newpwd;
    props.password = curpwd;
    if (props.lastLogin && props.lastLogin === '') {
      props.lastLogin = '1970-01-01T00:00:00.000Z';
    }

    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${props.token}`,
      },
      body: JSON.stringify(props),

    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          dialogClick('na', 'Password Update', responseJson.response, null);
        } else {
          dialogClick('na', 'Password Update', 'Your password has been updated', null);
        }
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        console.error(error);
      });
    // Hide the dialog
    this.hide();
  }
  const selectLanding = (event) => {
    data.user.landingPage = event.target.itemData.id;

    // Remove the New Password to avoid creating a new password
    data.user.newPassword = '';
    // Avoid Password comparison
    data.user.password = '';
    if (props.lastLogin && props.lastLogin === '') {
      props.lastLogin = '1970-01-01T00:00:00.000Z';
    }

    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${props.token}`,
      },
      body: JSON.stringify(data.user),
    })
      .then((response) => response.json())
      .then(() => {
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const selectIdle = (event) => {
    // console.log('select idle', event);
    data.user.idleLogout = event.target.itemData.id;
    setIdleLogout(event.target.itemData.id);
    localStorage.setItem('idleLogout', event.target.itemData.id);

    // Remove the New Password to avoid creating a new password
    data.user.newPassword = '';
    // Avoid Password comparison
    data.user.password = '';
    if (props.lastLogin && props.lastLogin === '') {
      props.lastLogin = '1970-01-01T00:00:00.000Z';
    }
    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${props.token}`,
      },
      body: JSON.stringify(data.user),
    })
      .then((response) => response.json())
      .then(() => {
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        console.error(error);
      });
  };
  function okProfileClick() {
    data.user.address = document.getElementById('address').value;
    data.user.address1 = document.getElementById('address1').value;
    data.user.city = document.getElementById('city').value;
    data.user.state = document.getElementById('state').value;
    data.user.zip = document.getElementById('zip').value;
    data.user.email = document.getElementById('email').value;
    data.user.mobile = document.getElementById('mobile').value;
    // Remove the New Password to avoid creating a new password
    data.user.newPassword = '';
    if (data.user.lastLogin && data.user.lastLogin === '') {
      data.user.lastLogin = '1970-01-01T00:00:00.000Z';
    }

    setIsClicked('notification', false);
    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${props.token}`,
      },
      body: JSON.stringify(data.user),
    })
      .then((response) => response.json())
      .then(() => {
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        console.error(error);
      });

    // Hide the dialog
    this.hide();
  }
  function cancelClick() {
    this.hide();
  }
  const buttonClick = () => {
    setIsClicked('profile', false);
    DialogUtility.confirm({
      title: ' Change Password Dialog',
      content: '<p>Current password:</p><input type="password" id="cpwd"  name="Required" class="e-input" placeholder="Type here.." />'
        + '<p>New password:</p><input type="password" id="npwd" name="Required" class="e-input" placeholder="Type here.." />'
        + '<p>Confirm New password:</p><input type="password" id="fpwd"  name="Required" class="e-input" placeholder="Type here.." />',
      okButton: { text: 'OK', click: okClick },
      cancelButton: { text: 'Cancel', click: cancelClick },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  };
  const optClick = () => {
    DialogUtility.alert({
      title: ' SMS Authentication Option',
      content: '<span style="display: block; text-align: center;">Want to use SMS to improve your Authentication process? </span>'
        + '<br /><br />'
        + '<span style="display: block; text-align: center;"><b>Text START or OPTIN to (567) 677-7684 to sign up for 2FA <br />(Two factor authentication)</b></p><br />'
        + '<p>Message frequency will be limited to your login requests for 2FA, Message and data rates may apply. Reply HELP for help or STOP to cancel.</p>'
        + '<br /><br /><p><a href="https://www.zackatlabs.com/privacy">Privacy&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a><a href="https://www.zackatlabs.com/tos">Terms of Service&nbsp;&nbsp;</a>',
      okButton: null,
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  };

  const profileClick = () => {
    setIsClicked('profile', false);
    DialogUtility.confirm({
      title: ' User Profile Dialog',
      content: '<p>Address:</p><input type="text" id="address"  name="address" class="e-input" placeholder="Type address here.." />'
        + '<p>Address cont. :</p><input type="text" id="address1" name="address1" class="e-input" placeholder="Type address here.." />'
        + '<p>City:</p><input type="text" id="city" name="city" class="e-input" placeholder="Type city here.." />'
        + '<p>State:</p><input type="text" id="state" name="state" class="e-input" placeholder="Type state here.." />'
        + '<p>Zip:</p><input type="text" id="zip" name="zip" class="e-input" placeholder="Type state here.." />'
        + '<p>Email:</p><input type="text" id="email" name="email" class="e-input" placeholder="Type email address here.." />'
        + '<p>Mobile:</p><input type="text" id="mobile" name="mobile" class="e-input" placeholder="Type mobile number here.." />',
      okButton: { text: 'OK', click: okProfileClick },
      cancelButton: { text: 'Cancel', click: cancelClick },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
    document.getElementById('address').value = data.user.address;
    document.getElementById('address1').value = data.user.address1;
    document.getElementById('city').value = data.user.city;
    document.getElementById('state').value = data.user.state;
    document.getElementById('zip').value = data.user.zip;
    document.getElementById('email').value = data.user.email;
    document.getElementById('mobile').value = data.user.mobile;
  };
  return (
    <div className="nav-item absolute right-1 top-16 bg-white dark:bg-[#42464D] p-8 rounded-lg w-96 zackat-divalh" id="profile">
      <div className="flex justify-between items-center">
        <p className="font-semibold text-lg dark:text-gray-200">User Profile</p>
        <Button
          icon={<MdOutlineCancel />}
          color="rgb(153, 171, 180)"
          bgHoverColor="light-gray"
          size="2xl"
          borderRadius="50%"
        />
      </div>
      {!isMobile && (
      <div className="flex gap-5 items-center mt-6 border-color border-b-1 pb-6">
        <img
          className="rounded-full h-24 w-24"
          src={data.user.image}
          alt="user-profile"
        />
        <div>
          <p className="font-semibold text-xl dark:text-gray-200"> {data.user.first} {data.user.last} </p>
          <p className="text-gray-500 text-sm dark:text-gray-400"> {data.role.name} </p>
          <p className="text-gray-500 text-sm font-semibold dark:text-gray-400"> {data.user.email} </p>
          <div className="flex">
            <DropDownListComponent id="ddllanding" floatLabelType="auto" dataSource={pages} placeholder="Select a landing page" value={data.user.landingPage} fields={fields} onChange={selectLanding} />
          </div>
          <div className="flex">
            <DropDownListComponent id="ddllogout" floatLabelType="auto" dataSource={idles} placeholder="Select a idle duration" value={data.user.idleLogout || '15'} fields={fields} onChange={selectIdle} />
          </div>
        </div>
      </div>
      )}
      <div>
        {!isMobile && userProfileData.map((item, index) => (
          <div
            key={index}
            className="flex border-b-1 border-color hover:bg-light-gray cursor-pointer  dark:hover:bg-[#42464D]"
          >
            <div style={containerStyle}>
              <ButtonComponent
                cssClass="e-small"
                id="targetButton"
                iconCss="e-icons e-password"
                onClick={buttonClick}
              >Password
              </ButtonComponent>
            </div>
            <div style={containerStyle1}>
              <ButtonComponent
                cssClass="e-small"
                id="profileButton"
                iconCss="e-icons e-edit-2"
                onClick={profileClick}
              >Profile
              </ButtonComponent>
            </div>
          </div>
        ))}
      </div>
      {/*
      {!isMobile && (
        <div className="control-section accordion-control-section">
          <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
            <AccordionComponent>
              <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                <span className=""> OPT IN/OUT </span>
                SMS Alerts<input
                  type="checkbox"
                  id="optinsms"
                  defaultValue={data.user.smsOptin}
                  defaultChecked={smsChecked}
                  onChange={handleChange}
                />
                <span>By checking this box you agree to receive Market SMS from Zackat Labs Inc. Message frequency varies. Message and data rates may apply. Reply STOP to opt out.</span>
                Email Alerts<input
                  type="checkbox"
                  id="optinemail"
                  defaultValue={data.user.emailOptin}
                  defaultChecked={emailChecked}
                  onChange={handleChange}
                />
              </div>
            </AccordionComponent>
          </div>
        </div>
      )}
      */}
      {!isMobile && data && data.user && data.user.mobile && data.user.mobile.length >= 10 && (
      <div className="control-section accordion-control-section">
        <div className="control Accordion-sample" style={{ margin: '4px 0' }}>
          <AccordionComponent>
            <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
              <span className="e-icons e-comments"> OPT IN/OUT </span>
              <div className="e-input-group">
                <div>
                  {/*
                  <br />
                  <label>SMS MARKETING&nbsp;&nbsp;</label>
                  <CheckBoxComponent
                    checked={smsCheckedMarketing}
                    id="optinsms1"
                    placeholder="SMS Marketing"
                    onChange={handleChange}
                    defaultValue={data.user.smsOptinMarketing}
                    cssClass="custom-checkbox"
                    title="SMS"
                  /> &nbsp;&nbsp;({data.user.mobile})
                  <div>
                    <p className="mt-2">By checking this box you agree to receive Marketing SMS from Zackat Labs Inc. Message frequency varies. Message and data rates may apply. Reply STOP to opt out.</p>
                  </div>
                  <br />
                  */ }
                  <label>SMS TRANSACTIONAL&nbsp;&nbsp;</label>
                  <CheckBoxComponent
                    checked={smsChecked}
                    id="optinsms"
                    placeholder="SMS Transactional"
                    onChange={handleChange}
                    defaultValue={data.user.smsOptin}
                    cssClass="custom-checkbox"
                    title="SMS"
                  /> &nbsp;&nbsp;({data.user.mobile})
                  <div>
                    <p className="mt-2">By checking this box you agree to receive Transactional SMS communications regarding account notifications and 2FA, from Zackat Labs Inc. Message frequency may vary. Message and data rates may apply. Reply STOP to opt out. Text HELP for assistance</p>
                    <div style={containerStyle1}>
                      <ButtonComponent
                        cssClass="e-small"
                        id="optButton"
                        iconCss="e-icons e-circle-info"
                        onClick={optClick}
                      >DOCUMENTATION
                      </ButtonComponent>
                    </div>
                  </div>
                  <br />
                  <label>EMAIL Opt In&nbsp;&nbsp;</label>
                  <CheckBoxComponent
                    checked={emailChecked}
                    id="optinemail"
                    placeholder="EMAIL OptIn"
                    onChange={handleChange}
                    defaultValue={data.user.email}
                    cssClass="custom-checkbox"
                    title="EMAIL"
                  /> &nbsp;&nbsp;({data.user.email})
                  <div>
                    <p className="mt-2">By checking this box you agree to receive Email communications from Zackat Labs Inc.</p>
                  </div>
                  <div style={{ display: 'flex', gap: '20px' }} className="mt-4">
                    <div style={{ flex: 1 }}>
                      <Link
                        to="https://www.zackatlabs.com/privacy"
                        target="_blank"
                        className="custom-linklayout"
                      >Privacy Policy
                      </Link>
                    </div>
                    <div style={{ flex: 1 }}>
                      <Link
                        to="https://www.zackatlabs.com/tos"
                        target="_blank"
                        className="custom-linklayout"
                      >Terms of Service
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </AccordionComponent>
        </div>
      </div>
      )}
      {!isMobile && data && data.user && data.user.mobile && data.user.mobile.length >= 10 && (
        <div className="control-section accordion-control-section">
          <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
            <AccordionComponent>
              <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                <div className="e-input-group">
                  <div className="mt-4">
                    <span className="e-icons e-unlock"> 2FA AUTHENTICATION </span>
                    {twoFA === 'na' ? (
                      <p>None</p>
                    ) : twoFA === 'sms' ? (
                      <p>SMS</p>
                    ) : twoFA === 'email' ? (
                      <p>EMAIL</p>
                    ) : (
                      <p>App</p>
                    )}
                  </div>
                </div>
                <div>
                  <div className="row">
                    <RadioButtonComponent label="None" name="2fa" value="na" checked={twoFA === 'na'} onChange={(v) => { handleChange(v); }} />
                  </div>
                  {data.user.smsOptin && (
                  <div className="row">
                    <RadioButtonComponent label={`SMS: ${formatPhoneNumber(data.user.mobile)}`} name="2fa" value="sms" checked={twoFA === 'sms'} onChange={(v) => { handleChange(v); }} />
                  </div>
                  )}
                  {data.user.emailOptin && (
                  <div className="row">
                    <RadioButtonComponent label={`EMAIL: ${data.user.email}`} name="2fa" value="email" checked={twoFA === 'email'} onChange={(v) => { handleChange(v); }} />
                  </div>
                  )}
                  <div className="row">
                    <RadioButtonComponent label="Authenticator App" name="2fa" value="authy" checked={twoFA === 'authy'} onChange={(v) => { handleChange(v); }} />
                  </div>
                  {twoFA === 'authy' && (
                  <div className="control-section accordion-control-section">
                    <div className="control Accordion-sample">
                      <AccordionComponent>
                        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                          <div className="e-input-group">
                            <div className="mt-4">
                              Scan QR Code into Authenticator App
                            </div>
                          </div>
                          <div className="image flex gap-4">
                            {qrcode && (
                            <div>
                              {REACT_APP_ENV === 'dev' ? (
                                <p>Account Name Zackat Labs DEV</p>
                              ) : REACT_APP_ENV === 'staging' ? (
                                <p>Account Name Zackat Labs STAGING</p>
                              ) : (
                                <p>Account Name Zackat Labs</p>
                              )}
                              <img
                                className="w-30 h-30"
                                src={qrcode}
                                alt="QRCode"
                              />
                              <div className="mt-4">
                                {/*
                                <TextBoxComponent
                                  value=""
                                  placeholder="PassCode"
                                  floatLabelType="Auto"
                                  cssClass="e-small e-outline"
                                />
                                <ButtonComponent
                                  cssClass="e-small"
                                  iconCss="e-icons e-opacity"
                                  style={{ float: 'left' }}
                                  onClick={(v) => { console.log('go verify the code'); }}
                                >Test
                                </ButtonComponent>
                                */}
                                <div className="bg-white rounded-sm e-otp-container" style={{ width: '100%' }}>
                                  Test your 6 digit passcode
                                  <OtpInputComponent
                                    className="e-otp-container e-otp-input"
                                    id="otpinput"
                                    length={6}
                                    type="number"
                                    valueChanged={handleValueChange}
                                  />
                                </div>

                              </div>
                            </div>
                            )}
                          </div>
                        </div>
                      </AccordionComponent>
                    </div>
                  </div>
                  )}
                </div>
              </div>
            </AccordionComponent>
          </div>
        </div>
      )}
      <div className="mt-5">
        <button
          type="button"
          onClick={() => handleSubmit()}
          title="Logout"
          style={{ backgroundColor: currentColor, color: 'white', borderRadius: '10px' }}
          className="text-xl p-3 w-full hover:drop-shadow-xl"
        >
          Logout
        </button>
        {/* {loggedIn ? <div>Your email address is {email}</div> : <div/>} */}
      </div>
    </div>

  );
};

export default UserProfile;
